import { has } from "lodash-es";
const dbtTypes = ['db', 'db_join', 'wuji1_0'];
export const useOrInsteadOfInMiddleware = async (ctx, next) => {
  const {
    useOrInsteadOfIn,
    collection,
    cgiName,
    requestConfig
  } = ctx;
  if (!useOrInsteadOfIn || !dbtTypes.includes(collection.type) || !/\w*(list|count)\w*/i.test(cgiName) // list count 和行版本接口
  ) {
    await next();
    return;
  }
  requestConfig.params = requestConfig.params || {};
  if (!has(requestConfig.params, 'useOrInsteadOfIn')) {
    requestConfig.params.useOrInsteadOfIn = '1';
  }
  await next();
};
//# sourceMappingURL=useOrInsteadOfIn.js.map
